import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: "absolute bg-yellow-50 z-50 p-4 right-0 left-0 m-4",
  style: {"box-shadow":"var(--black100) 4px 4px 7px 2px","border-radius":"5px"}
}
const _hoisted_2 = { class: "mt-2 flex flex-wrap" }
const _hoisted_3 = { class: "debug-chips" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("strong", null, "Unlocked: ", -1)
const _hoisted_5 = { class: "debug-chips" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("strong", null, "isShown: ", -1)
const _hoisted_7 = { class: "debug-chips" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("strong", null, "isShowDetectorSetup: ", -1)
const _hoisted_9 = { class: "debug-chips" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("strong", null, "isUnlockDetectorSetup: ", -1)
const _hoisted_11 = { class: "debug-chips" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("strong", null, "hasUnlockLogic: ", -1)
const _hoisted_13 = {
  key: 0,
  style: {"max-height":"350px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_button = _resolveComponent("a-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("strong", null, _toDisplayString(_ctx.fragenblock.getTitle()), 1),
    _createTextVNode(),
    _createVNode(_component_a_button, {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
    }, {
      default: _withCtx(() => [
        _createTextVNode(" Close ")
      ]),
      _: 1
    }),
    _createElementVNode("div", null, [
      _createElementVNode("span", null, _toDisplayString(_ctx.fragenblock.path), 1)
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("span", null, _toDisplayString(_ctx.fragenblock.isUnlocked()), 1)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createElementVNode("span", null, _toDisplayString(_ctx.fragenblock.isShown()), 1)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _createElementVNode("span", null, _toDisplayString(_ctx.fragenblock.isShowDetectorSetup), 1)
      ]),
      _createElementVNode("div", _hoisted_9, [
        _hoisted_10,
        _createElementVNode("span", null, _toDisplayString(_ctx.fragenblock.isUnlockDetectorSetup), 1)
      ]),
      _createElementVNode("div", _hoisted_11, [
        _hoisted_12,
        _createElementVNode("span", null, _toDisplayString(_ctx.fragenblock.freischaltunglogik && _ctx.isEmptyObject(_ctx.fragenblock.freischaltunglogik)), 1)
      ])
    ]),
    _createVNode(_component_a_button, {
      class: "mt-2",
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showJson = _ctx.showJson === 'frage' ? undefined : 'frage'))
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.showJson === 'frage' ? 'Hide ' : 'Show') + " Fragenblock Json ", 1)
      ]),
      _: 1
    }),
    (_ctx.showJson === 'frage')
      ? (_openBlock(), _createElementBlock("pre", _hoisted_13, _toDisplayString(_ctx.fragenblockJson), 1))
      : _createCommentVNode("", true)
  ]))
}